import { useState, useCallback } from "react";
import { ChatCardPropsType } from "./ChatCard";
// import { getSeedFileInfo } from "../../../api";
import "./chat.module.css";
import { getSeedFileInfo } from "../../../api";
import { BASE_FRONT_END_URL, BaseURL } from "../../../utils/appConstant";
import CitationHandler from "./CitationHandler";
export const RenderCitations = ({ isLoading, citations, onCitationClick }: ChatCardPropsType) => {
    const [showAll, setShowAll] = useState(false); // Add this
    const visibleCitations = showAll ? citations : citations && citations.slice(0, 5);

    return (
        <>
            {citations && Array.isArray(citations) && citations.length > 0 ? (
                <div className="w-full">
                    {/* {Array.isArray(citations) ? ( */}
                        <div className="text-sm  ">
                            <div>
                                <b className="heading_text_color pl-2">Citations:</b>

                                <ol className="list-decimal  citation pl-6 ">
                                    {visibleCitations?.map((item: any, index: number) => (
                                        <li key={index} className="">
                                            <CitationHandler citation={item} isLoading={isLoading} onCitationClick={onCitationClick} />
                                        </li>
                                    ))}
                                </ol>
                            </div>
                            <div className="pl-2">
                                {citations.length > 5 && (
                                    <button onClick={() => setShowAll(!showAll)} className="text-blue-600  hover:underline  text-sm mt-2">
                                        {showAll ? "Show less" : "Show more"}
                                    </button>
                                )}
                            </div>
                        </div>
                    {/* ) : (
                        typeof citations === "string" && <p>{citations}</p>
                    )} */}
                </div>
            ) : (
                ""
            )}
        </>
    );
};
